import 'scss/solutions/soundLibrary.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'
import { player } from 'js/libs/jplayer/init-audio'

var soundLibrary = (function (_self) {
  _self.data = [
    [
      // {
      //   imgUrl: '/hera/img/speaker-photo/small/xiaoyan.png',
      //   name: '虫虫',
      //   characteristic: '青年女声',
      //   voice: '甜美亲切',
      //   env: '录音棚',
      //   type: '品质库',
      //   playUrl: '//cdn.aidaxue.com/soundLibrary/chongchong'
      // },
      {
        imgUrl: '/hera/img/speaker-photo/small/yefang.png',
        name: '当当',
        characteristic: '青年女声',
        voice: '轻快自然',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/dangdang'
      },
      {
        imgUrl: '/hera/img/speaker-photo/small/xiaoyu.png',
        name: '宁宁',
        characteristic: '男童声',
        voice: '稚嫩童声',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/ningning'
      }
    ],
    [
      {
        imgUrl: '/hera/img/speaker-photo/small/hongshu.png',
        name: '超哥',
        characteristic: '青年男声',
        voice: '大气稳重',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/chaoge'
      },
      {
        imgUrl: '/hera/img/speaker-photo/small/lizhengchun.png',
        name: '刚哥',
        characteristic: '中年男声',
        voice: '深沉浑厚',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/gangge'
      },
      {
        imgUrl: '/hera/img/speaker-photo/small/hongshu.png',
        name: '七哥',
        characteristic: '青年男声',
        voice: '磁性浑厚',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/qige'
      }
    ],
    [
      {
        imgUrl: '/hera/img/speaker-photo/small/nannan.png',
        name: '百合仙子',
        characteristic: '青年女声',
        voice: '淡定',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/baihexianzi'
      },
      {
        imgUrl: '/hera/img/speaker-photo/small/lizhengchun.png',
        name: '大灰狼',
        characteristic: '中年男声',
        voice: '低沉',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/dahuilang'
      },
      {
        imgUrl: '/hera/img/speaker-photo/small/lizhengchun.png',
        name: '原野',
        characteristic: '中年男声',
        voice: '激情',
        env: '录音棚',
        type: '品质库',
        playUrl: '//cdn.aidaxue.com/soundLibrary/yuanye'
      }
    ]
  ]
  _self.setList = function (i) {
    var _html = ''
    var _list = _self.data[i]
    _list.forEach(element => {
      _html += `
        <ul>
          <li>
            <i><img src="${element.imgUrl}"></i>
            <span>${element.name}</span>
          </li>
          <li>${element.characteristic}</li>
          <li>${element.voice}</li>
          <li>${element.env}</li>
          <li>${element.type}</li>
          <li>
            <i class="voice-play" title="试听" data-play-url="${element.playUrl}"></i>
          </li>
        </ul>
      `
    })
    $('.solutions-item-apply .voice-table-content').html('').append(_html)
  }
  _self.playAudio = function (url) {
    player.buttonClick({
      wav: `${url}.wav`,
      mp3: `${url}.mp3`
    }, null, function () { }, function () {
      $('.voice-play').removeClass('voice-pause')
    }, function () {
      $('.voice-play').removeClass('voice-pause')
    })
  }
  _self.stopAudio = function () {
    player.stop()
  }
  return _self
})(window.soundLibrary || {})

$(function () {
  soundLibrary.setList(0)
  var bindEvent = function () {
    $('.voice-play').bind('click', function () {
      if ($(this).hasClass('voice-pause')) {
        $('.voice-play').removeClass('voice-pause')
        soundLibrary.stopAudio()
      } else {
        $('.voice-play').removeClass('voice-pause')
        $(this).addClass('voice-pause')
        soundLibrary.playAudio($(this).data('playUrl'))
      }
    })
  }
  bindEvent()
  $('.voice-scene-wrap .voice-scene').on('click', function () {
    soundLibrary.stopAudio()
    $('.voice-scene').removeClass('active')
    $(this).addClass('active')
    soundLibrary.setList($(this).data('index'))
    bindEvent()
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/soundLibrary.js